import styled from 'styled-components';

import { COLORS, DOCUSIGN, SECURE_BRAND, STATUS_COLORS } from '../../../../theme/tokens';

/** The picture fills its well's height, centred, and keeps its proportions (the well clips its sides). */
export const Picture = styled.svg`
  display: block;
  flex: 0 0 auto;
  height: 100%;
  width: auto;
  aspect-ratio: 240 / 148;
  overflow: visible;
`;

/** The page, lifted off the well. */
export const Sheet = styled.rect`
  filter: ${SECURE_BRAND.paperShadow};
`;

/**
 * The signature's ink, revealed along its length by the dash offset (`pathLength` 1). The gap is longer
 * than the path, so no dash wraps round to its far end, and the ink stays hidden until the first stroke:
 * a round cap would draw a dot even on a dash of no length.
 */
export const Signature = styled.path`
  fill: none;
  stroke: ${DOCUSIGN.signatureInk};
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 1 2;
`;

/** The check on the page's corner, scaled about its own middle. */
export const Check = styled.g`
  transform-box: fill-box;
  transform-origin: center;
`;

export const CheckDisc = styled.circle`
  fill: ${STATUS_COLORS.positive};
`;

export const CheckMark = styled.path`
  fill: none;
  stroke: ${COLORS.onAccent};
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
`;
